
  var rt = require("@stylable/runtime/dist/css-runtime-stylesheet.js");

  module.exports = rt.create(
      "Text2939314062",
      {"classes":{"root":"Text2939314062__root","size-tiny":"Typography612953122__size-tiny","size-small":"Typography612953122__size-small","size-medium":"Typography612953122__size-medium","size-large":"Typography612953122__size-large","weight-thin":"Typography612953122__weight-thin","weight-normal":"Typography612953122__weight-normal","weight-bold":"Typography612953122__weight-bold"},"vars":{},"stVars":{},"keyframes":{},"layers":{}},
      "",
      -1,
      module.id
  );
  